export default __webpack_public_path__ + "static/hiveonasic-header-71b7e615a79b08ee00126b46b579c8b9.svg";